export default __webpack_public_path__ + "static/media/close-custom-modal.17cc2e05.svg";